import { Form, Input, Select } from 'antd';
import PropTypes from 'prop-types';
import { ESTADOS } from 'constants/nombresCatalogos';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import './Ubicacion.scss';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import * as fieldMsgs from 'constants/formFieldsMessages';

const Ubicacion = ({ form, folio }) => {
  const estadosCat = useSelector(selectCatalogByName(ESTADOS));
  const [juntaLocalPorEstado, setJuntaLocalPorEstado] = useState({});
  const { data: usuario } = useSelector((state) => state.validarUsuario);

  const handleChangeJunta = (e) => {
    form.setFieldsValue({
      municipioId: null,
      calle: null,
      numeroExterior: null,
      colonia: null,
      codigoPostal: null,
      calle1: null,
      calle2: null,
      referencias: null
    });

    const juntaLocal = juntaLocalPorEstado?.find((junta) => junta.idDistritoFed === e);

    if (juntaLocal) {
      form.setFieldsValue({ municipioId: juntaLocal.idMunicipio });
      form.setFieldsValue({ calle: juntaLocal.calle });
      form.setFieldsValue({ numeroExterior: juntaLocal.numero });
      form.setFieldsValue({ colonia: juntaLocal.colonia });
      form.setFieldsValue({ codigoPostal: juntaLocal.codigoPostal });
    }
  };

  const handleSelectEstado = () => {
    form.setFieldsValue({
      distritoFedId: null,
      municipioId: null,
      calle: null,
      numeroExterior: null,
      colonia: null,
      codigoPostal: null,
      calle1: null,
      calle2: null,
      referencias: null
    });
  };

  return (
    <div>
      <Form form={form} layout="vertical">
        <div className="container-ubicacion">
          <Form.Item
            name="estadoId"
            label="Entidad:"
            rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
            <Select
              placeholder="Selecciona"
              style={{
                width: 200
              }}
              options={estadosCat}
              fieldNames={{
                value: 'idEstado',
                label: 'nombreEstado'
              }}
              filterOption={(inputValue, option) =>
                option.nombreEstado?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
              }
              disabled={folio && !usuario?.rol?.includes('SIMAC.ADMIN.OC')}
              showSearch
              onChange={handleSelectEstado}
            />
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) => {
              return prevValues.estadoId !== curValues.estadoId;
            }}>
            {() => {
              const { estadoId } = form.getFieldsValue('estadoId');
              // let juntaLocalPorEstado = {};
              if (estadoId !== undefined) {
                // juntaLocalPorEstado = estadosCat.find((edo) => edo.idEstado === estadoId);
                setJuntaLocalPorEstado(estadosCat.find((edo) => edo.idEstado === estadoId)?.juntas);
              }
              return (
                <Form.Item
                  name="distritoFedId"
                  label="No. Junta local:"
                  rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                  <Select
                    placeholder="Selecciona"
                    style={{
                      width: 300
                    }}
                    // options={juntaLocalPorEstado?.juntas}
                    options={juntaLocalPorEstado}
                    fieldNames={{
                      value: 'idDistritoFed',
                      label: 'nombreJunta'
                    }}
                    filterOption={(inputValue, option) =>
                      option.nombreJunta?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    showSearch
                    onChange={handleChangeJunta}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) => {
              return prevValues.estadoId !== curValues.estadoId;
            }}>
            {() => {
              const { estadoId } = form.getFieldsValue('estadoId');
              let municipiosPorEstado = {};
              if (estadoId !== undefined) {
                municipiosPorEstado = estadosCat.find((edo) => edo.idEstado === estadoId);
              }
              return (
                <Form.Item
                  name="municipioId"
                  label="Municipio:"
                  rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                  <Select
                    placeholder="Selecciona"
                    style={{
                      width: 200
                    }}
                    options={municipiosPorEstado?.municipios}
                    fieldNames={{
                      value: 'idMunicipio',
                      label: 'nombreMunicipio'
                    }}
                    filterOption={(inputValue, option) =>
                      option.nombreMunicipio?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    showSearch
                    // disabled={folio}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
          <Form.Item
            name="calle"
            label="Calle:"
            rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
            <Input
              placeholder="Escribe"
              maxLength={100}
              style={{
                width: 200
              }}
              // disabled={folio}
            />
          </Form.Item>
          <Form.Item
            name="numeroExterior"
            label="Número exterior:"
            rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
            <Input
              placeholder="Escribe"
              maxLength={100}
              style={{
                width: 200
              }}
              // disabled={folio}
            />
          </Form.Item>
        </div>
        <div className="container-ubicacion">
          <Form.Item
            name="colonia"
            label="Colonia:"
            rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
            <Input
              placeholder="Escribe"
              maxLength={100}
              style={{
                width: 200
              }}
              // disabled={folio}
            />
          </Form.Item>
          <Form.Item
            name="codigoPostal"
            label="Código postal:"
            rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
            <Input
              type="number"
              placeholder="Escribe"
              max={10}
              style={{
                width: 300
              }}
              // disabled={folio}
            />
          </Form.Item>
          <Form.Item name="calle1" label="Entre calle:">
            <Input
              placeholder="Escribe"
              maxLength={100}
              style={{
                width: 200
              }}
            />
          </Form.Item>
          <Form.Item name="calle2" label="Y calle:">
            <Input
              placeholder="Escribe"
              maxLength={100}
              style={{
                width: 200
              }}
            />
          </Form.Item>
          <Form.Item
            name="referencias"
            label="Referencias del lugar:"
            rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
            <Input.TextArea
              placeholder="Escribe"
              maxLength={100}
              style={{
                width: 200
              }}
            />
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default Ubicacion;

Ubicacion.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    resetFields: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired,
  folio: PropTypes.string
};

Ubicacion.defaultProps = {
  folio: null
};
